import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import SectorEditor from "../../editors/catalogue/sector";

const Sectors: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.SectorsList}
			endpoint={Endpoint.Sectors}
			addScreen={{ screen: SectorEditor, isAllowed: hasPermission(Permission.SectorsAdd) }}
			editScreen={{ screen: SectorEditor, isAllowed: hasPermission(Permission.SectorsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.SectorsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Sectors;
